import axios from "axios";
import jwt_decode from "jwt-decode";
import { exportFile } from "../helpers/common";

let SERVER_BASE_URL = process.env.REACT_APP_API_ENDPOINT;
let isTokenExpired = false;
let refreshTokenRequest = null;

const initHttp = (optionalHeaders) => {
  const now = new Date().getTime() / 1000;
  const actionTimeEnd = localStorage.getItem("actionTimeEnd");
  if (actionTimeEnd && now > actionTimeEnd) {
    localStorage.removeItem("authToken");
    localStorage.removeItem("token");
    localStorage.removeItem("actionTime");
    localStorage.removeItem("actionTimeEnd");
    window.location.href = "/login";
  }
  localStorage.setItem("actionTime", now);
  localStorage.setItem("actionTimeEnd", now + 7200);

  let authToken = localStorage.getItem("authToken");
  let headers = {
    "Content-Type": "application/json",
    "Accept-Language": "ja",
    "Access-Control-Allow-Credentials":"true",
    "Access-Control-Allow-Origin":"*",
    "X-Frame-Options": "SAMEORIGIN",
    "Referrer-Policy":	"strict-origin-when-cross-origin",
    "Strict-Transport-Security": "max-age=31536000",
    "X-Content-Type-Options":	"nosniff",
    "X-XSS-Protection":	"1; mode=block",
    "Access-Control-Allow-Methods": "DELETE, GET, HEAD, OPTIONS, POST, PUT",
    // "Content-Security-Policy": "default-src 'self'; script-src 'self' 'sha256-B/znvtEmOFOGNR02fa2aDVLWYzbIyDfGum5uLcV8dBg=' https://ssl.google-analytics.com https://apis.google.com https://ssl.gstatic.com; img-src 'self' data:; style-src 'self' 'sha256-47DEQpj8HBSa+/TImW+5JCeuQeRkm5NMpJWZG3hSuFU=' https://fonts.googleapis.com 'self' https://fonts.googleapis.com https://unpkg.com; font-src 'self' https://fonts.gstatic.com; frame-src 'self' https://accounts.google.com; connect-src 'self' https://dev-af.afterfit.site:9000 ; object-src 'none'",
    // "Access-Control-Expose-Headers": "*",
    ...optionalHeaders,
  };
  if (authToken) {
    headers["Authorization"] = `Bearer ${authToken}`;
  }

  let http = axios.create({
    headers,
  });
  http.interceptors.response.use(undefined, (err) => {
    const authToken = localStorage.getItem("authToken");
    if (authToken && err.response.status === 401) {
      localStorage.removeItem("authToken");
      localStorage.removeItem("token");
      localStorage.removeItem("actionTime");
      localStorage.removeItem("actionTimeEnd");
      window.location.href = "/login";
    }
    if (authToken && err.response.status === 403) {
      alert("不正な操作がありました。画面を表示し直してから再度実行願います。");
      window.location.href = "/";
    }
    return Promise.reject(err);
  });
  return http;
};

const refreshTokenApi = (path, data, headers) => {
  if (localStorage.getItem("authToken")) {
    localStorage.removeItem("authToken");
  }
  const requestUrl = SERVER_BASE_URL + path;
  const http = initHttp(headers);
  return new Promise((resolve, reject) => {
    http
      .post(requestUrl, data)
      .then((res) => {
        isTokenExpired = false;
        resolve(res.data.access_token);
      })
      .catch((error) => {
        localStorage.removeItem("authToken");
        localStorage.removeItem("token");
        localStorage.removeItem("actionTime");
        localStorage.removeItem("actionTimeEnd");
        window.location.href = "/login";
      });
  });
};

const fetch = async (type, path, data, resolve, reject, headers) => {
  await checkIsTokenExpired();
  const id_token = localStorage.getItem("token");
  if (isTokenExpired) {
    refreshTokenRequest = refreshTokenRequest
      ? refreshTokenRequest
      : refreshTokenApi("auth/google/login", data, {
          id_token: id_token,
        });
    const newToken = await refreshTokenRequest;
    refreshTokenRequest = null;
    localStorage.setItem("authToken", newToken);
    refreshTokenRequest = null;
  }
  const requestUrl = SERVER_BASE_URL + path;
  const http = initHttp(headers);
  if (type === "post") {
    http
      .post(requestUrl, data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((error) => {
        reject(error);
      });
  } else if (type === "get") {
    http
      .get(requestUrl, data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((error) => {
        reject(error);
      });
  } else if (type === "put") {
    http
      .put(requestUrl, data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((error) => {
        reject(error);
      });
  } else if (type === "delete") {
    http
      .delete(requestUrl, data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((error) => {
        reject(error);
      });
  }
};

const checkIsTokenExpired = async () => {
  let authToken = localStorage.getItem("authToken");
  return new Promise((resolve) => {
    if (authToken) {
      const expiration = jwt_decode(authToken).exp;
      const now = new Date().getTime() / 1000;
      const twoMinutes = 60 * 2;
      if (expiration - now < twoMinutes) {
        isTokenExpired = true;
      }
    }
    resolve(isTokenExpired);
  });
};

const postRequest = (path, data, resolve, reject, headers) => {
  fetch("post", path, data, resolve, reject, headers);
};

const getRequest = (path, data, resolve, reject, headers) => {
  fetch("get", path, data, resolve, reject, headers);
};

const putRequest = async (path, data, resolve, reject, headers) => {
  fetch("put", path, data, resolve, reject, headers);
};

const deleteRequest = async (path, data, resolve, reject, headers) => {
  fetch("delete", path, data, resolve, reject, headers);
};

const download = async (path, fileName, type, resolve, reject) => {
  const requestUrl = SERVER_BASE_URL + path;
  const http = initHttp({});
  http
    .get(requestUrl, {
      responseType: "arraybuffer",
    })
    .then((res) => {
      exportFile(res, fileName, type);
      resolve(res);
    })
    .catch((error) => {
      reject(error.response);
    });
};

const postAll = async (path, data, headers) => {
  const requestUrl = SERVER_BASE_URL + path;
  const http = initHttp(headers);
  return http.post(requestUrl, data);
};

export default {
  getRequest,
  postRequest,
  putRequest,
  deleteRequest,
  download,
  postAll,
};
